// extracted by mini-css-extract-plugin
module.exports = {"QuestionSection":"Question_QuestionSection__BWiKP","Question":"Question_Question__32II3"};